import type { ReactNode } from 'react';

import { sectionNumber } from '@/lib/utils';
import type { StepDefinition } from './questions';

interface QuestionStepProps {
  step: StepDefinition;
  children: ReactNode;
}

/**
 * Visual frame for a single questionnaire step. Marginalia + display
 * heading + lead + free-form slot for the control. Every individual
 * step component (GoalStep, AudienceStep, etc) wraps its inputs in
 * <QuestionStep step={step}>.
 */
export function QuestionStep({ step, children }: QuestionStepProps) {
  return (
    <section aria-labelledby={`step-${step.id}-title`}>
      <p className="marginalia">
        <span className="mr-2">{sectionNumber(step.index)}</span>
        {step.section}
      </p>
      <h2
        id={`step-${step.id}-title`}
        className="mt-3 font-serif text-display-md text-ink"
      >
        {step.title}
      </h2>
      <p className="mt-3 max-w-2xl text-base leading-relaxed text-graphite">
        {step.lead}
      </p>
      <div className="mt-10">{children}</div>
    </section>
  );
}
